import React from "react";

const FeedbackModal = ({ message, onClose }) => {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "300px",
                    textAlign: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
                }}
            >
                <p style={{ marginBottom: "20px" }}>{message}</p>
                <button
                    onClick={onClose}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "3px",
                        cursor: "pointer",
                    }}
                >
                    OK
                </button>
            </div>
        </div>
    );
};

export default FeedbackModal;